import axios from "axios";
import { api } from "../../api";
// add rsume
export const addResume = (data) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${api}/api/v2/add-resume`,
      data
    );
    console.log(response);
  } catch (error) {
    console.log(error.response);
  }
};

//get resume

export const getResume = () => async (dispatch) => {
  try {
    const response = await axios.get(`${api}/api/v2/get-resume`);

    dispatch({
      type: "RESUME_GET_SUCCESS",
      payload: response.data.resume
    });


  } catch (error) {
    console.log(error.response);
  }
};
